require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-tandoori-murgh.json") })
        }
      }, "path---recipes-tandoori-murgh");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-tandoori-murgh!./.cache/json/recipes-tandoori-murgh.json
// module id = 740
// module chunks = 231608221292675